<template>
  <v-dialog v-model="waitDialog" persistent width="50%">
    <v-card color="blue" dark>
      <v-card-text class="pt-5">
        <div class="subtitle-1 text-center pb-3">
          {{ $t("PleaseStandBy") }}
        </div>
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "WaitDialogComponent",
  props: ["waitDialog"]
};
</script>
